import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './views/Landing';


import { useApp } from './useApp';

const App: React.FC = () => {

    const { isLoading, error, isAuthenticated, user, handleLogout } = useApp();

    if (isLoading) return <h3>Loading...</h3>;
    if (error) return <h3>Ow Snap! Close this tab and retry</h3>;
    if (!isAuthenticated) return <h3>Not logged in</h3>;

    return (
        <Router>
            <Routes>
                <Route path="/" element={<Landing user={user} logout={handleLogout} />} />
                <Route path="/landing" element={<Landing user={user} logout={handleLogout} />} />
            </Routes>
        </Router>
    );
};

export default App;